import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ApprovalRefreshService {
  private _refreshTrigger = signal(0);

  readonly refreshTrigger = this._refreshTrigger.asReadonly();

  /**
   * Trigger a refresh event for approval-related components
   * This will notify all components listening to refreshTrigger to reload their data
   */
  triggerRefresh(): void {
    this._refreshTrigger.update((trigger) => trigger + 1);
  }
}

